import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const useCrmMeta = () => {
  const [services, setServices] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    api.get("/crm/services").then((r) => setServices(r.data)).catch(() => {});
    api.get("/crm/sellers").then((r) => setSellers(r.data)).catch(() => {});
    api.get("/crm/service-categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);
  return { services, sellers, categories };
};
